/* INTERHOUSE - GALERIJA */
(function () {
  var root = document.getElementById('ihg');
  if (!root) return;
  var wall = document.getElementById('gWall');
  if (!wall) return;

  var tiles = Array.prototype.slice.call(wall.querySelectorAll('.g-t'));
  if (!tiles.length) return;

  /* ---------- 1. isbarstome nuotraukas, kad viena po kitos nebutu is to paties objekto ---------- */
  (function shuffleByGroup() {
    var groups = [], map = {};
    tiles.forEach(function (t) {
      var k = t.getAttribute('data-p') || '0';
      if (!map[k]) { map[k] = []; groups.push(map[k]); }
      map[k].push(t);
    });
    if (groups.length < 2) return;
    groups.sort(function (a, b) { return b.length - a.length; });
    var out = [], left = true;
    while (left) {
      left = false;
      for (var i = 0; i < groups.length; i++) {
        if (groups[i].length) { out.push(groups[i].shift()); left = true; }
      }
    }
    var frag = document.createDocumentFragment();
    out.forEach(function (t) { frag.appendChild(t); });
    wall.appendChild(frag);
    tiles = out;
  })();

  tiles.forEach(function (t, i) {
    t.__i = i;
    var w = parseFloat(t.getAttribute('data-w')) || 0;
    var h = parseFloat(t.getAttribute('data-h')) || 0;
    t.__r = (w > 0 && h > 0) ? (w / h) : 1.5;
    if (t.__r < 0.42) t.__r = 0.42;
    if (t.__r > 3.4) t.__r = 3.4;
  });

  /* ---------- 2. tingus krovimas ---------- */
  function reveal(t) {
    var im = t.querySelector('img');
    if (!im || !im.getAttribute('data-src')) return;
    im.src = im.getAttribute('data-src');
    im.removeAttribute('data-src');
    if (im.complete && im.naturalWidth) t.classList.add('on');
    else im.addEventListener('load', function () { t.classList.add('on'); }, { once: true });
    im.addEventListener('error', function () { t.classList.add('on'); }, { once: true });
  }
  var io = null;
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '900px 0px' });
    tiles.forEach(function (t) { io.observe(t); });
  } else {
    tiles.forEach(reveal);
  }

  /* ---------- 3. isdelioma i lygias eiles ---------- */
  var density = 1; // 0 = didesnes, 1 = vidutines, 2 = maziau
  try { var d = localStorage.getItem('ihg-d'); if (d !== null) density = +d; } catch (e) {}

  function targetH(W) {
    var base;
    if (W < 560) base = 200;
    else if (W < 900) base = 250;
    else if (W < 1300) base = 300;
    else base = 340;
    if (density === 0) base = Math.round(base * 1.42);
    if (density === 2) base = Math.round(base * 0.68);
    return base;
  }

  var raf = window.requestAnimationFrame || function (f) { return setTimeout(f, 16); };

  function layout(animate) {
    var W = wall.clientWidth;
    if (!W) return;
    if (!animate) wall.classList.add('noanim');
    var target = targetH(W);
    var gap = W < 560 ? 6 : 10;
    var y = 0, row = [], ratio = 0;

    function flush(last) {
      var avail = W - gap * (row.length - 1);
      var h = avail / ratio;
      if (last && h > target * 1.34) h = target * 1.34;
      var x = 0;
      for (var i = 0; i < row.length; i++) {
        var t = row[i];
        var w = (i === row.length - 1 && !last) ? (W - x) : Math.round(h * t.__r);
        t.style.width = w + 'px';
        t.style.height = Math.round(h) + 'px';
        t.style.transform = 'translate3d(' + Math.round(x) + 'px,' + Math.round(y) + 'px,0)';
        x += w + gap;
      }
      y += Math.round(h) + gap;
      row = []; ratio = 0;
    }

    for (var i = 0; i < tiles.length; i++) {
      row.push(tiles[i]); ratio += tiles[i].__r;
      if (ratio * target + gap * (row.length - 1) >= W) flush(false);
    }
    if (row.length) flush(true);
    wall.style.height = Math.max(0, y - gap) + 'px';
    if (!animate) raf(function () { raf(function () { wall.classList.remove('noanim'); }); });
  }

  layout(false);
  window.addEventListener('load', function () { layout(false); });

  var rt;
  window.addEventListener('resize', function () {
    clearTimeout(rt);
    rt = setTimeout(function () { layout(false); }, 130);
  });

  /* ---------- 4. dydzio perjungimas ---------- */
  var seg = document.getElementById('gSeg');
  if (seg) {
    var btns = Array.prototype.slice.call(seg.querySelectorAll('button'));
    function sync() {
      btns.forEach(function (b) { b.setAttribute('aria-pressed', (+b.getAttribute('data-d') === density) ? 'true' : 'false'); });
    }
    sync();
    seg.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-d]');
      if (!b) return;
      density = +b.getAttribute('data-d');
      try { localStorage.setItem('ihg-d', density); } catch (err) {}
      sync();
      layout(true);
    });
  }

  /* ---------- 5. skaitymo juosta ---------- */
  var bar = document.getElementById('gBar');
  var prog = bar ? bar.querySelector('.g-prog i') : null;
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    raf(function () {
      ticking = false;
      if (bar) bar.classList.toggle('stuck', bar.getBoundingClientRect().top <= 0.5);
      if (prog) {
        var r = wall.getBoundingClientRect();
        var vh = window.innerHeight;
        var total = r.height - vh + 160;
        var done = total > 0 ? (-r.top + 80) / total : 1;
        prog.style.width = Math.max(0, Math.min(1, done)) * 100 + '%';
      }
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- 6. LIGHTBOX ---------- */
  var lb = document.getElementById('gLb');
  if (!lb) return;
  if (lb.parentNode !== document.body) document.body.appendChild(lb);
  var stage = lb.querySelector('.g-lb-stage');
  var imgA = lb.querySelector('.g-lb-img');
  var strip = lb.querySelector('.g-lb-strip');
  var cnt = lb.querySelector('.g-lb-sub');
  var openBtn = lb.querySelector('.g-lb-open');
  var prevB = lb.querySelector('.g-nav.prev');
  var nextB = lb.querySelector('.g-nav.next');
  var hint = lb.querySelector('.g-hint');
  var idx = 0, built = false, lastFocus = null, zoomed = false;
  var pre = [];

  function buildStrip() {
    if (built) return;
    built = true;
    var frag = document.createDocumentFragment();
    tiles.forEach(function (t, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.setAttribute('data-i', i);
      b.setAttribute('aria-label', (i + 1) + ' nuotrauka');
      var im = document.createElement('img');
      im.loading = 'lazy';
      im.decoding = 'async';
      im.alt = '';
      im.src = t.getAttribute('data-th');
      b.appendChild(im);
      frag.appendChild(b);
    });
    strip.appendChild(frag);
    strip.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-i]');
      if (b) { setPlay(false); go(+b.getAttribute('data-i')); }
    });
  }

  function preload(i) {
    if (i < 0 || i >= tiles.length) return;
    var u = tiles[i].getAttribute('data-full');
    if (pre.indexOf(u) > -1) return;
    pre.push(u);
    var im = new Image();
    im.src = u;
  }

  function unzoom() {
    zoomed = false;
    imgA.classList.remove('zoom');
    imgA.style.transform = '';
  }

  function show() {
    var t = tiles[idx];
    unzoom();
    lb.classList.add('load');
    imgA.classList.remove('on');
    var src = t.getAttribute('data-full');
    var tmp = new Image();
    tmp.onload = function () {
      if (tiles[idx] !== t) return;
      imgA.src = src;
      imgA.alt = t.querySelector('img') ? (t.querySelector('img').alt || '') : '';
      imgA.classList.add('on');
      lb.classList.remove('load');
    };
    tmp.onerror = function () { lb.classList.remove('load'); };
    tmp.src = src;
    if (tmp.complete) tmp.onload();

    cnt.textContent = (idx + 1) + ' / ' + tiles.length;
    if (openBtn) openBtn.href = src;
    prevB.disabled = false; nextB.disabled = false;

    var cur = strip.querySelector('button[aria-current="true"]');
    if (cur) cur.removeAttribute('aria-current');
    var b = strip.querySelector('button[data-i="' + idx + '"]');
    if (b) {
      b.setAttribute('aria-current', 'true');
      var l = b.offsetLeft - strip.clientWidth / 2 + b.offsetWidth / 2;
      strip.scrollTo ? strip.scrollTo({ left: l, behavior: 'smooth' }) : (strip.scrollLeft = l);
    }
    preload(idx + 1); preload(idx + 2); preload(idx - 1);
  }

  function go(i) {
    idx = (i + tiles.length) % tiles.length;
    show();
  }

  function open(i) {
    lastFocus = document.activeElement;
    buildStrip();
    idx = i;
    lb.hidden = false;
    document.body.classList.add('ihg-lock');
    raf(function () { lb.classList.add('in'); });
    show();
    nextB.focus();
    if (hint) {
      try {
        if (!localStorage.getItem('ihg-hint')) {
          hint.classList.add('show');
          setTimeout(function () { hint.classList.remove('show'); }, 4200);
          localStorage.setItem('ihg-hint', '1');
        }
      } catch (e) {}
    }
  }

  function close() {
    setPlay(false);
    lb.classList.remove('in');
    document.body.classList.remove('ihg-lock');
    setTimeout(function () { lb.hidden = true; imgA.removeAttribute('src'); }, 260);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  wall.addEventListener('click', function (e) {
    var t = e.target.closest('.g-t');
    if (!t) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    open(tiles.indexOf(t));
  });

  /* automatine perziura */
  var playBtn = lb.querySelector('.g-lb-play');
  var timer = null;
  function setPlay(on) {
    if (!playBtn) return;
    playBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
    playBtn.querySelector('.i-play').hidden = on;
    playBtn.querySelector('.i-pause').hidden = !on;
    clearInterval(timer);
    timer = on ? setInterval(function () { go(idx + 1); }, 3600) : null;
  }
  if (playBtn) playBtn.addEventListener('click', function () {
    setPlay(playBtn.getAttribute('aria-pressed') !== 'true');
  });

  prevB.addEventListener('click', function () { setPlay(false); go(idx - 1); });
  nextB.addEventListener('click', function () { setPlay(false); go(idx + 1); });
  lb.querySelector('.g-lb-close').addEventListener('click', close);

  lb.addEventListener('click', function (e) {
    if (e.target === stage || e.target === lb) close();
  });

  /* zoom */
  imgA.addEventListener('click', function (e) {
    e.stopPropagation();
    if (zoomed) { unzoom(); return; }
    var r = imgA.getBoundingClientRect();
    var ox = ((e.clientX - r.left) / r.width) * 100;
    var oy = ((e.clientY - r.top) / r.height) * 100;
    zoomed = true;
    imgA.classList.add('zoom');
    imgA.style.transformOrigin = ox + '% ' + oy + '%';
    imgA.style.transform = 'scale(2)';
  });

  document.addEventListener('keydown', function (e) {
    if (lb.hidden) return;
    if (e.key === 'Escape') { e.preventDefault(); zoomed ? unzoom() : close(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); setPlay(false); go(idx + 1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); setPlay(false); go(idx - 1); }
    else if (e.key === 'Home') { e.preventDefault(); setPlay(false); go(0); }
    else if (e.key === 'End') { e.preventDefault(); setPlay(false); go(tiles.length - 1); }
    else if (e.key === ' ') { e.preventDefault(); if (playBtn) playBtn.click(); }
  });

  /* braukimas */
  var sx = 0, sy = 0, moved = false;
  stage.addEventListener('touchstart', function (e) {
    if (e.touches.length !== 1) return;
    sx = e.touches[0].clientX; sy = e.touches[0].clientY; moved = false;
  }, { passive: true });
  stage.addEventListener('touchmove', function (e) {
    if (e.touches.length !== 1) return;
    if (Math.abs(e.touches[0].clientX - sx) > 12) moved = true;
  }, { passive: true });
  stage.addEventListener('touchend', function (e) {
    if (!moved || zoomed) return;
    var dx = e.changedTouches[0].clientX - sx;
    var dy = e.changedTouches[0].clientY - sy;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(idx + (dx < 0 ? 1 : -1));
    else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close();
  }, { passive: true });
})();
